module.exports = __webpack_public_path__ + "static/media/cancelwhite.1cf4af66.svg";